import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import clsx from 'clsx';
import { useTheme } from '@paypalcorp/pp-react-theme';
import '../__generated__/styles/loading-spinner.css';

var styles = {"ppvx_loading-spinner":"ppvx_loading-spinner___2-7-10","border-spinner":"border-spinner___2-7-10","ppvx_loading-spinner--size_xs":"ppvx_loading-spinner--size_xs___2-7-10","ppvx_loading-spinner--size_md":"ppvx_loading-spinner--size_md___2-7-10","ppvx_loading-spinner--size_lg":"ppvx_loading-spinner--size_lg___2-7-10","ppvx_loading-spinner--size_xl":"ppvx_loading-spinner--size_xl___2-7-10","ppvx_loading-spinner--inverse":"ppvx_loading-spinner--inverse___2-7-10","ppvx_loading-spinner__screenreader":"ppvx_loading-spinner__screenreader___2-7-10","ppvx--v2":"ppvx--v2___2-7-10","ppvx--v1":"ppvx--v1___2-7-10"};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var loadingSpinnerClass = 'ppvx_loading-spinner';
var srClass = styles["".concat(loadingSpinnerClass, "__screenreader")];
var sizes = {
  xs: styles["".concat(loadingSpinnerClass, "--size_xs")],
  // to be used for stateful buttons ONLY.
  sm: '',
  md: styles["".concat(loadingSpinnerClass, "--size_md")],
  lg: styles["".concat(loadingSpinnerClass, "--size_lg")],
  xl: styles["".concat(loadingSpinnerClass, "--size_xl")]
};

var LoadingSpinner = function (_ref) {
  var _clsx;

  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'p' : _ref$as,
      className = _ref.className,
      inverse = _ref.inverse,
      size = _ref.size,
      screenReaderText = _ref.screenReaderText,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["as", "className", "inverse", "size", "screenReaderText", "theme"]);

  var _theme = useTheme('Loading Spinner', theme);

  return React.createElement(as, _objectSpread({
    className: clsx(styles[loadingSpinnerClass], sizes[size], (_clsx = {}, _defineProperty(_clsx, styles["".concat(loadingSpinnerClass, "--inverse")], inverse), _defineProperty(_clsx, styles['ppvx--v2'], _theme && _theme === 'v2'), _clsx), className),
    role: 'alert'
  }, rest), /*#__PURE__*/React.createElement("span", {
    className: srClass
  }, screenReaderText));
};

export { LoadingSpinner };
